
/* LoQuieroIA — Votaciones IA Descubre */
(function () {
  'use strict';

  const ENDPOINT = 'https://script.google.com/macros/s/AKfycbz2S2vfE-a2Q4Bs1Q6IwfXfK6alaUfoKP19WL8D_1Ru5wkIJ7K8RLjM66_g7b9eSC0Z5g/exec';

  const ID_KEY = 'loquieroia_ia_descubre_vote_id';
  const VOTED_PREFIX = 'loquieroia_iad_voted_';

  function getVoteId() {
    let id = localStorage.getItem(ID_KEY);

    if (!id) {
      id = window.crypto && crypto.randomUUID
        ? crypto.randomUUID()
        : 'v-' + Date.now() + '-' + Math.random().toString(36).slice(2);

      localStorage.setItem(ID_KEY, id);
    }

    return id;
  }

  function updateButton(button, message, disabled) {
    button.disabled = disabled;

    const label = button.querySelector('.lq-discover-want__text');
    const heart = button.querySelector('.lq-discover-want__heart');

    if (label) label.textContent = message;
    else button.textContent = message;

    if (heart && disabled) heart.textContent = '♥';
  }

  function initializeVotes() {
    document.querySelectorAll('.lq-discover-want[data-product-id]')
      .forEach(function (button) {
        if (button.dataset.voteInitialized) return;
        button.dataset.voteInitialized = '1';

        const productId = button.dataset.productId;
        const votedKey = VOTED_PREFIX + productId;

        const box = button.closest('.lq-discover-box');
        const feedback = box
          ? box.querySelector('.lq-discover-feedback')
          : null;

        if (localStorage.getItem(votedKey) === '1') {
          updateButton(button, 'Voto enviado', true);
          if (feedback) {
            feedback.hidden = false;
            feedback.textContent = 'Ya enviaste tu interés desde este navegador.';
          }
          return;
        }

        button.addEventListener('click', async function () {
          if (button.disabled) return;

          updateButton(button, 'Enviando...', true);
          if (feedback) feedback.hidden = true;

          const productName =
            button.dataset.productName ||
            document.querySelector('h1')?.textContent?.trim() ||
            productId;

          try {
            await fetch(ENDPOINT, {
              method: 'POST',
              mode: 'no-cors',
              headers: {
                'Content-Type': 'text/plain;charset=utf-8'
              },
              body: JSON.stringify({
                productId: productId,
                productName: productName,
                voteId: getVoteId()
              })
            });

            localStorage.setItem(votedKey, '1');
            updateButton(button, 'Voto enviado', true);

            if (feedback) {
              feedback.hidden = false;
              feedback.textContent =
                'Solicitud enviada. Registro pendiente de verificación.';
            }
          } catch (error) {
            button.disabled = false;
            updateButton(button, 'Lo quiero', false);

            if (feedback) {
              feedback.hidden = false;
              feedback.textContent =
                'No se pudo enviar. Inténtalo nuevamente.';
            }
          }
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVotes);
  } else {
    initializeVotes();
  }

  document.addEventListener('shopify:section:load', initializeVotes);
})();
